import { OptionDefinition } from "@amzn/awsui-components-react/polaris/internal/components/option/interfaces";
import { Region } from "./types";

let regionsList : Region[] | undefined = undefined;

export function generateRegionsOptions(regionsList: Region[]): OptionDefinition[] {
    return regionsList.map((region) => {
        return {
            label: region.airportCode + ' (' + region.regionCode + ')',
            value: region.airportCode.toLowerCase(),
        }
    })
}

export function seperateStringContents(value: string) {
    return value.split(/\(|\|/)
}

export function getDomainFromHost() {
    let host = window.location.host;
    if (isLocalhost()) {
        return `dev-${process.env.REACT_APP_USER}`
    } else if (host.indexOf(".people.aws.dev") >= 0) {
        // https://opsconsole.{username}.people.aws.dev/
        let domain = host.substring(host.indexOf('opsconsole.') + 'opsconsole.'.length, host.indexOf(".people.aws.dev"));
        return "dev-" + domain;
    } else if (host.indexOf(".beta.opsconsole.amazonmq.") >= 0) {
        return "beta";
    } else if (host.indexOf(".gamma.opsconsole.amazonmq.") >= 0) {
        return "gamma";
    } else {
        return "prod";
    }
}

export function getRegionFromHost() {
    let host = window.location.host;
    if (isLocalhost()) {
        return "us-west-2";
    } else if (host.indexOf(".people.aws.dev") >= 0) {
        return "us-west-2";
    } else if (host.indexOf(".beta.opsconsole.amazonmq.") >= 0) {
        return host.substring(0, host.indexOf(".beta."));
    } else if (host.indexOf(".gamma.opsconsole.amazonmq.") >= 0) {
        return host.substring(0, host.indexOf(".gamma."));
    } else {
        return host.substring(0, host.indexOf(".opsconsole.amazonmq."));
    }
}

export function buildHostForDomainAndRegion(domain: string, regionNotAirport: string) {
    if (isLocalhost()) {
        return 'localhost.a2z.com:3000'
    } else if (domain === "prod") {
        if (regionNotAirport === "cn-north-1" || regionNotAirport === "cn-northwest-1") {
            return `${regionNotAirport}.opsconsole.amazonmq.a2z.org.cn`
        }
        return `${regionNotAirport}.opsconsole.amazonmq.aws.dev`
    } else if (isDevDomain(domain)) {
        let username = extractUsernameFromDevDomain(domain);
        return `opsconsole.${username}.people.aws.dev`
    } else {
        if (regionNotAirport === "cn-north-1" || regionNotAirport === "cn-northwest-1") {
            return `${regionNotAirport}.${domain}.opsconsole.amazonmq.a2z.org.cn`
        }
        return `${regionNotAirport}.${domain}.opsconsole.amazonmq.aws.dev`
    }
}

export function isLocalhost() {
    return window.location.href.indexOf('localhost.a2z.com') >= 0;
}

export function isDevDomain(domain: string) {
    return domain.startsWith("dev-");
}

export function extractUsernameFromDevDomain(domain: string) {
    return domain.substring(4);
}

export async function getRegions(): Promise<Region[]> {
    if (!regionsList) {
        const fullHostname = window.location.protocol + '//' + window.location.host;
        const regions = await fetch(`${fullHostname}/regions.json`)
        regionsList = await regions.json() as Region[];
    }
    return Promise.resolve(regionsList!)
}

export function createIsengardLink(isengardEndpoint: string, accountId: string, role: string, destination: string) {
    return `${isengardEndpoint}/federate?account=${accountId}&role=${role}&destination=${encodeURIComponent(destination)}`;
}

export function capitalize(s: string) {
    if (s.length === 0) {
        return s;
    }
    return s[0].toUpperCase() + s.slice(1);
}